import React from 'react';
import './Footer.css'; // Make sure to import the CSS file

const Footer = () => {
    return (
        <div className="footer">
            <p className='text-container'>Designed by Tom BT 2023 with care for little learners.</p>
        </div>
    );
};

export default Footer;
